// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"906d008e","453":"e7f7ed4a","455":"6c6202af","977":"cbb9b34c"}[chunkId] + ".chunk.js";
};